import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data"]

import {
  onMounted,
  ref,
  watchEffect,
  PropType,
  onUnmounted,
  computed,
} from "vue";
import { BarChartData } from "@/interface/real.time.data";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4chart from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useOptionStore } from "@/store/option";
import { celsiusToFahrenheit } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  props: {
  size: {
    type: String,
    default: () => "",
  },
  data: {
    type: Array as PropType<BarChartData[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props

const optionStore = useOptionStore();



const chartData = computed(() => {
  return props.data.map((data) => {
    return {
      ...data,
      value:
        optionStore.$state.unitSystem === "metric"
          ? data.value
          : celsiusToFahrenheit(data.value),
    };
  });
});

const chartRef = ref<any>(null);

onMounted(() => {
  am4core.useTheme(am4themes_animated);

  const chart = am4core.create(chartRef.value, am4chart.XYChart);
  chart.data = [];

  const xAxis = chart.xAxes.push(new am4chart.CategoryAxis());
  xAxis.dataFields.category = "name";
  xAxis.renderer.minGridDistance = 40;
  xAxis.renderer.grid.template.disabled = true;
  xAxis.renderer.labels.template.fontWeight = "bold";
  xAxis.renderer.labels.template.fontSize = "12px";
  xAxis.renderer.labels.template.fill = am4core.color("#ffffff");

  const yAxis = chart.yAxes.push(new am4chart.ValueAxis());
  yAxis.max = 200;
  yAxis.min = 0;
  yAxis.renderer.grid.template.disabled = true;
  yAxis.renderer.labels.template.disabled = true;

  const series = chart.series.push(new am4chart.ColumnSeries());
  series.dataFields.valueY = "value";
  series.dataFields.categoryX = "name";
  series.columns.template.strokeOpacity = 0;
  series.columns.template.column.cornerRadiusTopRight = 10;
  series.columns.template.column.cornerRadiusTopLeft = 10;

  const columnTemplate = series.columns.template;
  columnTemplate.maxWidth = 60;
  columnTemplate.strokeOpacity = 0;
  columnTemplate.strokeWidth = 0;
  columnTemplate.tooltipText = "{valueY} ℃";
  columnTemplate.propertyFields.fill = "color";

  // series.heatRules.push({
  // 	target: columnTemplate,
  // 	property: 'fill',
  // 	dataField: 'valueY',
  // 	min: am4core.color('#9FD3FE'),
  // 	max: am4core.color('#8892D6'),
  // })

  const labelBullet = series.bullets.push(new am4chart.LabelBullet());
  labelBullet.label.verticalCenter = "bottom";
  labelBullet.dy = -5;
  labelBullet.label.text = "{valueY} ℃";
  labelBullet.label.fill = am4core.color("#ffffff");
  labelBullet.label.fontSize = 12;
  labelBullet.label.fontWeight = "bold";

  watchEffect(() => {
    if (chartData.value) {
      chart.data = chartData.value;
    }
  });

  watchEffect(() => {
    if (optionStore.$state.unitSystem === "metric") {
      labelBullet.label.text = "{valueY} ℃";
      columnTemplate.tooltipText = "{valueY} ℃";

      yAxis.max = 200;
    } else {
      labelBullet.label.text = "{valueY} °F";
      columnTemplate.tooltipText = "{valueY} °F";

      yAxis.max = 400;
    }

    chart.invalidateData();
  });

  onUnmounted(async () => {
    chart.dispose();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    data: props.data,
    style: _normalizeStyle(props.size),
    ref_key: "chartRef",
    ref: chartRef
  }, null, 12, _hoisted_1))
}
}

})